import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import PaymentMethodSelector from "./PaymentMethodSelector";
import { Dimmer, Loader } from "semantic-ui-react";
import getSymbolFromCurrency from "currency-symbol-map";
import { getSelectPaymentMethods, putPaymentProvider } from "./apiProntoPaga";
import NextStepComponent from "../NextStepComponent";
import { Button, Card, Col, Collapse, Container, Row } from "reactstrap";
import { formatNumber } from "../../utils/utils";
import { useAuth } from "../shared/AuthContext/AuthContext";
import { getPaymentButtonStatus } from "../../service/api";
import { useAlert } from "../shared/AlertContext/AlertContext";
import { ALERT_TYPES } from "../../utils/Constants";

const ProntoPagaHome = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isRedirectBool, setIsRedirectBool] = React.useState(false);
  const [succesMessage, setSuccesMessage] = React.useState(false);
  const [errorMessageShow, setErrorMessageShow] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [typeNextStep, setTypeNextStep] = React.useState("");
  const [showUrl, setShowUrl] = React.useState("");
  const [isSendPut, setIsSendPut] = React.useState(false);
  const [paymentMethodsObj, setPaymentMethodsObj] = React.useState(null);
  const [selectedMethod, setSelectedMethod] = React.useState(null);

  const { tenant, publicKey } = useParams();
  const { getAuthToken } = useAuth();
  const showNotification = useAlert();

  const EMBEDDED = "EMBEDDED";
  const REDIRECT = "REDIRECT";
  const MESSAGE = "MESSAGE";
  const ERROR = "ERROR";

  const desactiveIsLogin = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    if (isRedirectBool) {
      setTimeout(() => {
        setIsRedirectBool(false);
      }, 1000);
    }
  };

  const getPaymentMethods = async () => {
    const accessToken = await getAuthToken();

    getSelectPaymentMethods(accessToken, tenant, publicKey)
      .then((response) => {
        const responseData = response.data;

        setPaymentMethodsObj(responseData);
      })
      .catch((error) => {
        if (error.response.status === 404) {
          getStatusInfoPayment();
          return;
        }
        setErrorMessageShow(error.response?.data?.responseMessage);
        setTypeNextStep(ERROR);
      })
      .finally(() => {
        desactiveIsLogin();
      });
  };

  const getStatusInfoPayment = async () => {
    const accessToken = await getAuthToken();
    getPaymentButtonStatus(accessToken, tenant, publicKey)
      .then((response) => {
        const responseData = response.data;
        if (responseData.urlRedirect && responseData.urlRedirect.trim()) {
          window.location.replace(responseData.urlRedirect);
        } else {
          return;
        }
      })
      .catch((error) => {
        setErrorMessageShow(error.response?.data?.responseMessage);
        setTypeNextStep(ERROR);
      });
  };

  const putPayment = async () => {
    const accessToken = await getAuthToken();

    if (selectedMethod && selectedMethod?.method) {
      setIsLoading(true);

      putPaymentProvider(accessToken, publicKey, tenant, selectedMethod.method)
        .then((result) => {
          const responseData = result.data;
          if (responseData.responseCode === 1000) {
            if (responseData.structure != null && responseData.structure.url != null) {
              if (responseData.structure.url.mode === REDIRECT) {
                setShowUrl(responseData.structure.url.url);
                setTypeNextStep(REDIRECT);
                desactiveIsLogin();
              } else {
                setTypeNextStep(MESSAGE);
                desactiveIsLogin();
              }
            }
            setSuccesMessage(true);
          } else {
            showNotification(responseData.responseMessage, ALERT_TYPES.error);
          }
        })
        .catch((error) => {
          console.error("Error updating payment:", error);
          showNotification(error.response.data.responseMessage ?? error.message, ALERT_TYPES.error);
        })
        .finally(() => {
          setIsLoading(false);
          desactiveIsLogin();
        });
    }
  };

  useEffect(() => {
    if (paymentMethodsObj === null) {
      setIsLoading(true);
      getPaymentMethods();
    }
  }, []);

  const handleConfirm = (selectedMethod) => {
    setIsSendPut(true);
    setSelectedMethod(selectedMethod);
  };

  return (
    <>
      {isLoading && (
        <Dimmer active>
          <Loader size="massive">Loading</Loader>
        </Dimmer>
      )}
      {isRedirectBool && (
        <Dimmer active>
          <Loader size="massive">You will be redirected to a secure page.</Loader>
        </Dimmer>
      )}
      {!succesMessage && !errorMessageShow && (
        <>
          <br></br>
          <Container fluid>
            <Row className="justify-content-center sticky-total">
              <Col xs="12" md="8" className="text-center">
                <Card body className="p-0 ">
                  <Row className="align-items-center p-3">
                    <Col md={6} xs={6} className="text-left">
                      <p className="font-weight-bold">Total ({paymentMethodsObj?.currency})</p>
                    </Col>
                    <Col md={6} xs={6} className="text-right">
                      <h5 className="font-weight-bold">
                        {getSymbolFromCurrency(paymentMethodsObj?.currency)}{" "}
                        {formatNumber(paymentMethodsObj?.amount, 2)}
                      </h5>
                    </Col>
                    <Collapse isOpen={isSendPut} className="w-100">
                      <Col md={12} className="d-flex justify-content-center ">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => putPayment()}
                          className="w-100"
                        >
                          NEXT STEP
                        </Button>
                      </Col>
                    </Collapse>
                  </Row>
                </Card>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col xs="12" md="8">
                <p className="font-weight-bold">Select a provider</p>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xs={12} md={8}>
                <Card>
                  <PaymentMethodSelector
                    paymentMethods={paymentMethodsObj?.paymentMethods}
                    onConfirm={handleConfirm}
                  />
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}

      {succesMessage && (
        <NextStepComponent
          message={errorMessage}
          typeMessage={typeNextStep}
          url={showUrl}
        ></NextStepComponent>
      )}
      {errorMessageShow && (
        <NextStepComponent message={errorMessage} typeMessage={typeNextStep}></NextStepComponent>
      )}
    </>
  );
};

export default ProntoPagaHome;
